import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Breadcrumbs, RouteLayout } from '@web/app/components'
import { Shield } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/security')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Seguridad',
      icon: Shield,
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
      <Breadcrumbs basePath={Route.fullPath} fd={'row'} ai={'center'} gap={'$1'} mb={'$true'} />
      <Outlet />
    </RouteLayout>
  )
}
